import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  promoImg: {
    width: '100%',
    marginBottom: '3.5rem'
  },
  tabTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    marginBottom: 8,
    color: theme.palette.text.secondary
  },
  contentContainer: {
    width: '100%',
    marginTop: theme.spacing(2),
    marginBottom: 32
  },
  paragraph: {
    marginTop: 10,
    marginBottom: 14,
    fontSize: '1rem',
    lineHeight: 1.7,
    color: theme.palette.text.primary
  },
  basicList: {
    paddingLeft: 24,
    margin: 0,

    '& li': {
      marginBottom: 12,
      fontSize: '1rem',
      lineHeight: 1.7,
      color: theme.palette.text.primary
    }
  },
  dotList: {
    paddingLeft: 24,
    marginTop: 16,

    '& li': {
      marginBottom: 12,
      fontSize: '1rem',
      lineHeight: 1.7,
      color: theme.palette.text.primary
    }
  },
  cardsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 16,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)'
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr'
    }
  },
  separator: {
    width: '100%',
    height: 1,
    backgroundColor: theme.palette.divider,
    margin: '32px 0'
  }
}))
